class API {
    constructor() {
        this._url = 'https://ratonera.net/api';
        this.headers = {
            'Content-Type': 'application/json',
        };

        if (localStorage.getItem('token')) {
            this.token = localStorage.getItem('token');
            this.headers['Authorization'] = `Bearer ${this.token}`;
        } else {
            this.token = null;
        }
    }

    setToken(token) {
        if (!token) {
            return console.error('No token provided');
        }

        this.token = token;
        this.headers['Authorization'] = `Bearer ${this.token}`;
    }

    removeToken() {
        this.token = null;
        delete this.headers['Authorization'];
    }

    async ret(response, args = {}) {
        const silent = args.silent || false;

        // TODO: error validations

        if (!response) {
            return { error: response.status, message: response.statusText };
        }

        const data = await response.json();
        if (data && data.error) {
            console.error(data);
            if (!silent) {
                alert(data.error);
            }
            return data;
        }
        return data;
    }

    async get(path = null, args = {}) {
        if (!path)
            return console.error('No path provided');

        const response = await fetch(`${this._url}${path}`, {
            method: 'GET',
            headers: this.headers,
        });
        if (args.raw === true) {
            return response;
        }

        return this.ret(response, args);
    }
    async post(path = null, data = {}, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data),
        });
        if (args.raw === true)
            return response;
        return this.ret(response, args);
    }
    async postFormData(path = null, data = {}, args = {}) {
        const formData = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                formData.append(key, data[key]);
            }
        }

        const headers = new Headers();
        headers.append("Authorization", this.headers["Authorization"]);

        const response = await fetch(`${this._url}${path}`, {
            method: "POST",
            headers: headers,
            body: formData,
        });
        return response;
    }
    async delete(path = null, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'DELETE',
            headers: this.headers,
            // headers: this.headers,,
        });
        return this.ret(response, args);
    }
    async put(path = null, data = {}, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'PUT',
            headers: this.headers,
            // headers: this.headers,,
            body: JSON.stringify(data),
        });
        return this.ret(response, args);
    }
}

const api = new API();

export default api;